import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class StateCultureEditService {

  private apiUrl = globalConst.baseAPI;
  constructor(private http: Http) { }

  loadStateCulture(token, ID) {

		return this.http
		.get(this.apiUrl + "stateculture/v1/getcodculture/" + ID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

  updateStateCulture(token, stateCulture: any) {
  	console.log(stateCulture);

  	return this.http
  		.put(this.apiUrl + "stateculture/v1/updateculture", stateCulture, JSON.parse(localStorage.getItem('yara.connectionHeader')))
  		.map((res: Response) => res.json())
  		.catch(e => {
  			if (e.status === 401) {
  				return Observable.throw('Unauthorized');
  			}
  		});
  }

}



// WEBPACK FOOTER //
// ./src/app/stateculture/service/stateculture-edit/stateculture-edit.service.ts